export default {"src":"/_next/static/media/info_error.6028bb5c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};